import { GeoFrame } from "./geoframe";
export const DSGeoFrame = GeoFrame;
export * from "./stereogeoframecollection";
//# sourceMappingURL=internal.js.map